<wvr-it-works-component [text]="text"></wvr-it-works-component>
